import { render } from "./BusinessInfo.vue?vue&type=template&id=214b673e&scoped=true"
import script from "./BusinessInfo.vue?vue&type=script&lang=js"
export * from "./BusinessInfo.vue?vue&type=script&lang=js"

import "./BusinessInfo.vue?vue&type=style&index=0&id=214b673e&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-214b673e"]])

export default __exports__